import React from 'react';

import Footer from '../../../components/Footer';
import Header from '../../../components/Header';
import { Wrapper, Container, Content, Body } from './styles';

const DefaultLayout: React.FC = ({ children }) => {
  return (
    <Wrapper>
      <Container>
        <Content>
          <Header />
          <Body>{children}</Body>
        </Content>
      </Container>
      <Footer />
    </Wrapper>
  );
};

export default DefaultLayout;
